import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d9ecc48"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/img/logos/Logo_Thunnissen.jpg",
  width: "140",
  alt: "Logo van Thunnissen"
}, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Wachtwoord vergeten", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Om uw wachtwoord te herstellen kunt u hieronder uw e-mailadres invullen. Nadat u op wachtwoord herstellen heeft geklikt ontvangt u een e-mail met verdere instructies.", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "E-mailadres", -1))

import { authStore } from '@/stores/auth'
import { computed, ref } from 'vue'
import { useRouter } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'ForgotPassword',
  setup(__props) {

const router = useRouter()
const email = ref('')
const validEmail = computed(() => {
  return /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email.value)
})

return (_ctx: any,_cache: any) => {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createBlock(_component_a_row, { style: {"height":"100vh","margin":"0"} }, {
    default: _withCtx(() => [
      _createVNode(_component_a_col, {
        xs: 24,
        md: 12,
        xl: 16,
        class: "login-image"
      }),
      _createVNode(_component_a_col, {
        xs: 24,
        md: 12,
        xl: 8,
        style: {"padding":"64px 16px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_row, { style: {"margin-bottom":"64px"} }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, {
                span: 20,
                offset: 2
              }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, {
                span: 20,
                offset: 2
              }, {
                default: _withCtx(() => [
                  _hoisted_2,
                  _hoisted_3,
                  _createVNode(_component_a_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _hoisted_4,
                          _createVNode(_component_a_input, {
                            type: "email",
                            value: email.value,
                            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event))
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_button, {
                            type: "primary",
                            class: "fw-btn",
                            style: {"margin-bottom":"16px"},
                            loading: _unref(authStore)().loading,
                            disabled: !_unref(validEmail) || _unref(authStore)().loading,
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(authStore)().forgotPassword(email.value)))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Wachtwoord herstellen")
                            ]),
                            _: 1
                          }, 8, ["loading", "disabled"]),
                          _createVNode(_component_a_button, {
                            type: "link",
                            class: "fw-btn",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(router).push({ name: 'Login' })))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Terug naar inloggen")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})